import React from 'react';

// ---------------HANDLING PAGE ERROR-----------

const NotFound = () => {
    return (
        <div>
            <h1 style={{ textAlign: "center" }}>404 page not found</h1>
        </div>
    );
};

export default NotFound;